import React from 'react';
import { CheckFull, Info, WarningFull, X } from '@fabric-ui/icons';
import { FailFull } from '@fabric-ui/icons/colorful';
import { IconButton, Slide } from '@mui/material';
import { SnackbarProvider } from 'notistack';

const iconVariants = {
  success: <CheckFull />,
  error: <WarningFull />,
  warning: <WarningFull />,
  info: <Info />,
  static: <FailFull style={{ width: 22, height: 22 }} />,
};

export default function AvNotificationProvider({ children }: React.PropsWithChildren = {}): React.ReactNode {
  const notificationRef = React.createRef<SnackbarProvider>();
  const onClickDismiss = (e, key) => {
    e.stopPropagation();
    notificationRef.current?.closeSnackbar(key);
  };

  const dismiss = key => (
    <IconButton aria-label="close" color="inherit" onClick={e => onClickDismiss(e, key)}>
      <X />
    </IconButton>
  );
  return (
    <SnackbarProvider
      maxSnack={2}
      preventDuplicate
      domRoot={document.body}
      ref={notificationRef}
      iconVariant={iconVariants}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      action={dismiss}
      TransitionComponent={Slide}>
      {children}
    </SnackbarProvider>
  );
}
